module.exports = __webpack_public_path__ + "media/images/Video-blue-a312cf36.png";